import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.report-status-completed .p-tag {
	background: ${dt('reportStatusTag.completed.background')};
	color: ${dt('reportStatusTag.completed.color')};
}`;
